import { mapState } from 'vuex';
import { vuetifyColors } from '@/utils/themes';
const defaultItemsPerPage = 10;
export default {
  name: 'CoreVirtualDeviceUploadList',
  props: {
    tblHeaders: {
      type: Array,
      default: new Array()
    },
    contents: {
      type: Array,
      default: new Array()
    }
  },
  data: function () {
    return {
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      },
      searchItem: null,
      expanded: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])
  },
  methods: {
    filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    getColor(type) {
      return vuetifyColors[type];
    }
  }
};